import { PayloadAction } from '@reduxjs/toolkit';
import { MetadataPayload } from './types';
import { initialState } from './index';

export const reducers = {
  getMetadata(state) {
    state.isLoading = true;
  },
  getMetadataSuccess(state, action: PayloadAction<MetadataPayload>) {
    const { itemsMetadata, valveType } = action.payload;
    state.isLoading = false;
    state.error = null;
    state.data[valveType] = itemsMetadata;
  },
  getMetadataFail(state, action: PayloadAction<unknown>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },
};
